module.exports = __webpack_public_path__ + "static/media/background.ef7da4bb.avif";